import {EmptyControl, HvlQueryModel} from "@hvlng/framework-bff/core";
import {JsonObject, JsonProperty} from "json2typescript";

@JsonObject('KovanHrLookupQueryModel')
export class LookupQueryModel extends HvlQueryModel{
    @EmptyControl()
    @JsonProperty('id', Number, true)
    id?: number = null;

    @EmptyControl()
    @JsonProperty('text', String, true)
    text?: string = null;

    @EmptyControl()
    @JsonProperty('uuidList', [String], true)
    uuidList?: string[] = null;

    @EmptyControl()
    @JsonProperty('codeList', [String], true)
    codeList?: string[] = null;


}
